export default "__VITE_ASSET__Zz1NoiC9__"